import { useContext } from 'react';
import { Form } from 'react-bootstrap';

import { useTrackEvent } from '@/App/Blotter/useTrackEvent.ts';
import { OrderRow } from '@/App/tiles/orders/components/OrderRow.tsx';
import { FixingContext, useValidateFixing } from '@/App/tiles/orders/FixingOrder/FixingContext.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import { selectFixingPlace, selectFixingSourceNameOfSelectedType } from '@/store/orders/fixing/selectors.ts';

export const FixingPlace = () => {
  const tileId = useContext(FixingContext).tileId;
  const fixingPlace = useAppSelector((state) => selectFixingPlace(state, tileId));
  const sourceNameOfSelectedType = useAppSelector((state) => selectFixingSourceNameOfSelectedType(state, tileId));
  const track = useTrackEvent();

  const validateFixing = useValidateFixing();

  const handleChangePlace = (event: React.ChangeEvent<HTMLSelectElement>) => {
    track('Order action', 'Fixing place changed');
    const newPlace = event.target.value;

    validateFixing({
      fixingPlace: newPlace,
    });
  };

  return (
    <OrderRow labelId="order.fields.fixingPlace">
      <Form.Select value={fixingPlace} onChange={handleChangePlace} size="sm" data-e2e="fixing-place-selector">
        {sourceNameOfSelectedType?.map((sourceName) => (
          <option key={sourceName} value={sourceName}>
            {sourceName}
          </option>
        ))}
      </Form.Select>
    </OrderRow>
  );
};
